import { UntypedFormGroup } from '@angular/forms';

export function RegistrationValidator(pwd: string, confirmPwd: string) {
	return (formGroup: UntypedFormGroup) => {
		const control = formGroup.controls[pwd];
		const matchingControl = formGroup.controls[confirmPwd];

		if (matchingControl.errors && !matchingControl.errors.mustMatch) {
			// return if another validator has already found an error on the matchingControl
			return;
		}

		// set error on matchingControl if validation fails
		if (control.value !== matchingControl.value) {
			matchingControl.setErrors({ mustMatch: true });
		} else {
			matchingControl.setErrors(null);
		}
	};
}
